import(/* webpackMode: "eager" */ "/root/workspace/__flow_work/__flow_builds/99b45c14-05f6-49fe-9b23-60d9cf1c98b4/workspace/lych-dg-pc_T57I/src/app/error.tsx");
